import { render, staticRenderFns } from "./AssemblySheetOtherItemsFragment.vue?vue&type=template&id=1f38846c"
import script from "./AssemblySheetOtherItemsFragment.vue?vue&type=script&lang=js"
export * from "./AssemblySheetOtherItemsFragment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports